import { render, staticRenderFns } from "./VideoBottomBar.vue?vue&type=template&id=2dbe6709&scoped=true"
import script from "./VideoBottomBar.vue?vue&type=script&lang=js"
export * from "./VideoBottomBar.vue?vue&type=script&lang=js"
import style0 from "./VideoBottomBar.vue?vue&type=style&index=0&id=2dbe6709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe6709",
  null
  
)

export default component.exports